import React from 'react';
import { Container, Title, Text, Button, Group, Stack } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { IconHome } from '@tabler/icons-react';
import { ExamPortalHeader } from './examportal/components/ExamPortalHeader';
import Footer from '../components/layout/Footer';
import './NotFoundPage.css';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-wrapper">
      <ExamPortalHeader />
      <main className="not-found-main">
        <Container size="md" className="not-found-container">
          <Stack align="center" gap="xl">
            <div className="not-found-illustration">
              <div className="not-found-404">404</div>
              <div className="not-found-circle"></div>
            </div>

            <div className="not-found-content">
              <Title className="not-found-title">Lost in Space?</Title>
              <Text size="lg" className="not-found-text">
                The page you are looking for doesn't exist or has been moved. Don't worry, even the
                best explorers get lost sometimes.
              </Text>
            </div>

            <Group justify="center">
              <Button
                size="lg"
                variant="filled"
                color="violet"
                leftSection={<IconHome size={20} />}
                onClick={() => navigate('/dashboard')}
                className="not-found-button"
              >
                Back to Home
              </Button>
            </Group>
          </Stack>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
